import { UserProfile } from "./user-profile";
import { TypeCredit } from './type-credit';

export class ObjProfilTypeCred
{
    id: number|undefined;
    userProfile:UserProfile;
    typeCredit:TypeCredit;
    nbJourDossier:number;
}